import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getNotificationDestinations } from 'services/WebHooksService'
import { API_PAGINATION_LIMIT, API_PAGINATION_OFFSET } from 'utils/pagination'

export const useNotificationDestinationsQuery = (
  search?: string,
  size = API_PAGINATION_LIMIT,
  page = API_PAGINATION_OFFSET,
  sort = '',
  enabled = true
) => {
  return useQuery({
    queryKey: reactQueryKeys.destinations(size, page, sort),
    queryFn: () => getNotificationDestinations({ search, size, page, sort }),
    enabled,
  })
}